import PolicyPage from '@/components/pageEditor/PolicyPage';

// المحتوى من قاعدة البيانات (صفحات الموقع) ويتعدّل من الواجهة للأدمن
const ReturnPolicy = () => <PolicyPage slug="return-policy" />;

export default ReturnPolicy;
